import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { PrintersPage } from './_dashboard.devices.printers'

export const Route = createFileRoute('/_dashboard/devices/printers/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: PrintersItemPage,
})

function PrintersItemPage() {
  const { item } = Route.useParams()
  return <PrintersPage selectedId={item} />
}
